import {
  aTagSchema,
  aTagSchemaValueOption,
  mockTagSchemasQueryOperationQuery,
  TagContentType,
} from '__generated__';

export const handlers = [
  mockTagSchemasQueryOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        tagSchemas: [
          aTagSchema({
            contentTypeEnums: [
              TagContentType.Rule,
              TagContentType.CustomInsight,
            ],
            freeform: false,
            key: '_mitreAttackTactic',
            label: 'Tactic',
            valueOptionObjects: [aTagSchemaValueOption()],
            contentTypes: null,
            valueOptions: null,
          }),
        ],
      })
    );
  }),
];
